import { checkDueDate } from 'lib/checkContentDueDate';

// Run on initial page load
document.addEventListener("DOMContentLoaded", function() {
  checkDueDate();
});

document.addEventListener("content-card:replaced", (e) => {
  checkDueDate();
});
